import { useState } from "react";
import { FiChevronDown, FiChevronUp, FiExternalLink } from "react-icons/fi";
import RowActionsCompetition from "./RowActionsCompetition";

const ProductCard = ({ product, onEdit, onSetUser, onChangeAct }) => {
  const [expanded, setExpanded] = useState(false);

  return (
<div className="grid w-full grid-cols-[minmax(0,1fr)_auto] items-start gap-2">
      <div
        className="
          w-full
          overflow-hidden
          rounded-sm
          border border-gray-200
          bg-white
        mb-1
          transition-all
          hover:border-gray-200
          hover:shadow-md
        "
      >
        {/* PRODUCT HEADER */}
        <div
          onClick={() => setExpanded(prev => !prev)}
          className="
            cursor-pointer
            px-2 py-3
            sm:px-2 sm:py-3
            hover:bg-gray-50/70
            transition-colors
          "
        >
          <div className="flex items-start justify-between gap-3">

            {/* LEFT */}
            <div className="min-w-0 flex-1">

              {/* NAME + STATUS */}
              <div className="flex flex-wrap items-center gap-2">

                {product.isActive == 0 ? (
                  <span
                    className="
                      inline-flex shrink-0 items-center gap-1.5
                      rounded-full
                      bg-red-50
                      px-2 py-0.5
                      text-[10px] sm:text-[11px]
                      font-medium
                      text-red-700
                    "
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-red-500" />
                    Nieaktywne
                  </span>
                ) : (
                  <span
                    className="
                      inline-flex shrink-0 items-center gap-1.5
                      rounded-full
                      bg-emerald-50
                      px-2 py-0.5
                      text-[10px] sm:text-[11px]
                      font-medium
                      text-emerald-700
                    "
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                    Aktywne
                  </span>
                )}

                <span className="min-w-0 truncate text-xs font-semibold text-gray-800">
                  {product.name}
                </span>

                <span
                  className={`text-xs font-semibold ${
                    Number(product.assigned_users) === 0
                      ? "text-red-600"
                      : "text-gray-500"
                  }`}
                >
                  ({product.assigned_users ?? 0})
                </span>

                {product.offers > 1 && (
                  <span
                    className="
                      shrink-0
                      rounded-full
                      bg-blue-50
                      px-2 py-0.5
                      text-[10px]
                      font-medium
                      text-blue-600
                    "
                  >
                    {product.offers} ofert
                  </span>
                )}
              </div>

              {/* META */}
              <div
                className="
                  mt-2
                  flex
                  flex-wrap
                  gap-x-3 gap-y-1
                  text-[10px] sm:text-[11px]
                  text-gray-400
                "
              >
                {product.pn && (
                  <span className="whitespace-nowrap">
                    <span className="font-medium text-gray-500">PN:</span>{" "}
                    {product.pn}
                  </span>
                )}

                {product.ean && (
                  <span className="whitespace-nowrap">
                    <span className="font-medium text-gray-500">EAN:</span>{" "}
                    {product.ean}
                  </span>
                )}

                {product.category && (
                  <span className="max-w-[180px] truncate">
                    <span className="font-medium text-gray-500">
                      Kategoria:
                    </span>{" "}
                    {product.category}
                  </span>
                )}

                {product.brand && (
                  <span className="whitespace-nowrap">
                    <span className="font-medium text-gray-500">
                      Marka:
                    </span>{" "}
                    {product.brand}
                  </span>
                )}
              </div>
            </div>

            {/* RIGHT */}
            <div className="flex shrink-0 items-center gap-2 sm:gap-4">

              {/* PRICE */}
              <div className="text-right">
                <div className="text-sm sm:text-base font-bold text-green-600">
                  {Number(product.min_price).toFixed(2)} zł
                </div>

                <div className="hidden sm:block text-[10px] text-gray-400">
                  najniższa cena
                </div>
              </div>

              {/* CHEVRON */}
              <div
                className="
                  flex h-7 w-7
                  items-center justify-center
                  rounded-full
                  bg-gray-50
                  text-gray-400
                  transition-colors
                "
              >
                {expanded ? (
                  <FiChevronUp size={16} />
                ) : (
                  <FiChevronDown size={16} />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* DETAILS */}
        {expanded && (
          <div
            className="
              border-t border-gray-100
              bg-gray-50/70
              px-3 py-3
              sm:px-4 sm:py-4
            "
          >
            {/* DESKTOP HEADER */}
            <div
              className="
                hidden
                md:grid
                grid-cols-10
                gap-3
                px-3 pb-2
                text-[10px]
                font-semibold
                uppercase
                tracking-wide
                text-gray-400
              "
            >
              <div className="col-span-3">Sklep</div>
              <div className="col-span-3">Sprzedawca</div>
              <div className="col">Cena</div>
              <div className="col-span-2">Data</div>
              <div className="col text-right">Link</div>
            </div>

            {/* OFFERS */}
            <div className="space-y-1">
              {product.details?.map(item => (
                <div
                  key={item.id}
                  className="
                    rounded-xs
                    border border-gray-200
                    bg-white
                    p-2
                 
                    md:grid
                    md:grid-cols-10
                    md:items-center
                    md:gap-3
                  "
                >
                  {/* SHOP */}
                  <div className="md:col-span-3">
                    <div className="text-xs font-semibold text-gray-900">
                      {item.shop}
                    </div>
                  </div>

                  {/* SELLER */}
                  <div className="mt-1 md:mt-0 md:col-span-3">
                    <span className="text-[10px] text-gray-400 md:hidden">
                      Sprzedawca:{" "}
                    </span>

                    <span className="text-xs text-gray-500">
                      {item.seller ?? "-"}
                    </span>
                  </div>

                  {/* PRICE */}
                  <div className="mt-2 md:mt-0 md:col">
                    <span className="text-[10px] text-gray-400 md:hidden">
                      Cena:{" "}
                    </span>

                    <span className="text-sm font-bold text-green-600">
                      {Number(item.price).toFixed(2)} zł
                    </span>
                  </div>

                  {/* DATE */}
                  <div className="mt-1 md:mt-0 md:col-span-2">
                    <span className="text-[10px] text-gray-400 md:hidden">
                      Data:{" "}
                    </span>

                    <span className="text-xs text-gray-500">
                      {item.date}
                    </span>
                  </div>

                  {/* LINK */}
                  <div className="mt-2 md:mt-0 md:col md:text-right">
                    {item.link && (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                        onClick={e => e.stopPropagation()}
                        className="
                          inline-flex
                          items-center
                          gap-1.5
                          rounded-md
                          bg-primary-400
                          px-2.5 py-1.5
                          text-xs
                          font-medium
                          text-white
                          transition-colors
                          hover:bg-primary-500
                          hover:text-white
                        "
                      >
                        <FiExternalLink size={12} />
                        Otwórz
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* ACTIONS */}
     <div className="shrink-0">
    <RowActionsCompetition
      row={product}
      onEdit={onEdit}
      onSetUser={onSetUser}
      onChangeActive={onChangeAct}
    />
  </div>
    </div>
  );
};



export default function BrandlyServiceComponent({
    data,
    loading = false,
    loadNewData,
    onEdit,
    onSetUser,
    onChangeAct

}) {




  //  console.log("Count:", all);
const products = data?.dane ?? [];
const limit = data?.limit ?? [];
const all = data?.countAll ?? 0;
const page = data?.page ?? 1;
const totalPages = Math.ceil(all / limit);

const paginatedData = products;

const getPages = () => {
    const pages = [];

    if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
        pages.push(1);

        if (page > 3) pages.push("...");

        for (
            let i = Math.max(2, page - 1);
            i <= Math.min(totalPages - 1, page + 1);
            i++
        ) {
            pages.push(i);
        }

        if (page < totalPages - 2) pages.push("...");

        pages.push(totalPages);
    }

    return pages;
};
    if (loading) {

        return (
            <div className="
                flex
                justify-center
                items-center
                h-64
            ">
                <div className="
                    animate-spin
                    rounded-full
                    h-8
                    w-8
                    border-b-1
                    border-primary-600
                "></div>
            </div>
        );

    }



    if (!products.length) {

        return (
            <div className="
                bg-white
                border
                border-gray-200
                rounded-md
                p-6
                text-center
                text-gray-400
                text-sm
            ">
                Brak produktów
            </div>
        );

    }



    return (

        <div className="flex flex-col h-full">

<div className="flex-1 overflow-y-auto">
 {paginatedData.map(product => (

                <ProductCard
                    key={product.id}
                    product={product}
                    onEdit={onEdit}
                    onSetUser={onSetUser}
                    onChangeAct={onChangeAct}
                />

            ))}
</div>
           
<div className="flex flex-row lg:flex-row items-center justify-between gap-4 mt-1 p-2 bg-white border border-gray-200 rounded-xs">

    {/* Ilość produktów */}
    <div className="flex items-center gap-2 text-sm text-gray-600">
        {/* <span className=" font-medium">Pokaż</span>

        <select
            value={pageSize}
            onChange={(e) => {
                setPageSize(Number(e.target.value));
                setPage(1);
            }}
            className="
                h-6 px-3 
                border border-gray-300 
                rounded-lg 
                bg-white 
                text-xs
                outline-none
                hover:border-blue-400
                focus:ring-2 focus:ring-blue-200
                transition
            "
        >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
        </select>

        <span>produktów</span> */}
    </div>


    {/* Paginacja */}
    <div className="flex items-center gap-1">

        <button
           onClick={() => loadNewData(page - 1, limit)}
            disabled={page === 1}
            className="
                w-6 h-6
                flex items-center justify-center
                rounded-xs
                border border-gray-200
                bg-white
                text-gray-600
                hover:bg-gray-50
                hover:border-gray-300
                disabled:opacity-40
                disabled:cursor-not-allowed
                transition
            "
        >
            ←
        </button>


        {getPages().map((item, index) =>
            item === "..." ? (
                <span
                    key={index}
                    className="w-6 h-6 flex items-center justify-center text-gray-400"
                >
                    ...
                </span>
            ) : (
                <button
                    key={item}
                      onClick={() => {
                        loadNewData(item, limit);
                        //setPage(item);
                            }}
                    className={`
                        w-6 h-6
                        rounded-xs
                        border
                        text-xs
                        font-medium
                        transition-all

                        ${
                            page === item
                            ? "bg-primary-600 text-white border-primary-600 shadow-sm"
                            : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50 hover:border-gray-300"
                        }
                    `}
                >
                    {item}
                </button>
            )
        )}


        <button
           onClick={() => loadNewData(page + 1, limit)}
            disabled={page === totalPages}
            className="
                w-6 h-6
                flex items-center justify-center
                rounded-xs
                border border-gray-200
                bg-white
                text-gray-600
                hover:bg-gray-50
                hover:border-gray-300
                disabled:opacity-40
                disabled:cursor-not-allowed
                transition
            "
        >
            →
        </button>

    </div>


    {/* Zakres */}
    <div className="
        text-xs 
        text-gray-500
        bg-gray-50
        px-3
        py-2
        rounded-xs
        border border-gray-100
    ">
        <span className="font-medium text-gray-700">
            {(page - 1) * limit + 1}
        </span>
        {" – "}
        <span className="font-medium text-gray-700">
            {Math.min(page * limit, products.length)}
        </span>
        {" z "}
        {all}
    </div>

</div>
        </div>

    );
}